import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  listData: {},

  activePackagePending: false,
  activePackageSuccess: false,
  activePackageError: null,
  getAvailablePackagesPending: false,
  getAvailablePackagesError: null,
  availablePackages: {},
  activatedPackage: null,
  getUpgradablePackagesResult: {},

}

const packageReducer = (state = initialState, { type, action, error }) => {
  switch (type) {

    case types.GET_PACKAGE_LIST_BY_USER_ID_REQUEST: {
      return {
        ...state,
        waiting: true,
        success: false,
        error: '',
        // listData: {}
      }
    }

    case types.GET_PACKAGE_LIST_BY_USER_ID_SUCCESS: {
      return {
        ...state,
        waiting: false,
        success: true,
        error: '',
        listData: action.data
      }
    }

    case types.GET_PACKAGE_LIST_BY_USer_ID_ERROR: {
      return {
        ...state,
        waiting: false,
        error: '',
        success: false,
        listData: {}
      }
    }

    case types.ACTIVE_PACKAGE_FOR_USER_REQUEST: {

      return {
        ...state,
        activePackagePending: true,
        activePackageSuccess: false,
        activePackageError: false,

      }
    }

    case types.ACTIVE_PACKAGE_FOR_USER_SUCCESS: {
      return {
        ...state,
        activePackagePending: false,
        activePackageSuccess: true,
        activatedPackage: action.data
      }
    }

    case types.ACTIVE_PACKAGE_FOR_USER_ERROR: {
      return {
        ...state,
        activePackagePending: false,
        activePackageError: error?.response?.data,

      }
    }


    case types.UPDATE_PACKAGE_REQUEST: {

      return {
        ...state,
        updatePackagePending: true,
        updatePackageSuccess: false,
        updatePackageError: false,

      }
    }

    case types.UPDATE_PACKAGE_REQUEST_SUCCESS: {

      return {
        ...state,
        updatePackagePending: false,
        updatePackageSuccess: true,
        updatedPackage: action.data
      }
    }

    case types.UPDATE_PACKAGE_REQUEST_ERROR: {
      return {
        ...state,
        updatePackagePending: false,
        updatePackageError: error?.response?.data?.message,

      }
    }

    ////-----------------------start available-packages----------------
    case types.AVAILABLE_PACKAGE_LIST_REQUEST: {

      return {
        ...state,
        getAvailablePackagesPending: true,
        getAvailablePackagesError: '',
        activePackageSuccess: false,
        // availablePackages: {}

      }
    }

    case types.AVAILABLE_PACKAGE_LIST_SUCCESS: {
      return {
        ...state,
        getAvailablePackagesPending: false,
        availablePackages: action.data
      }
    }

    case types.AVAILABLE_PACKAGE_LIST_ERROR: {
      return {
        ...state,
        getAvailablePackagesPending: false,
        getAvailablePackagesError: error?.response?.data?.message,

      }
    }
    ////-----------------------end available-packages----------------



    ////-----------------------start invoice-detail----------------
    case types.GET_USER_INVOICE_REQUEST: {

      return {
        ...state,
        getInvoiceDetailPending: true,
        getInvoiceDetailError: '',

      }
    }

    case types.GET_USER_INVOICE_SUCCESS: {
      return {
        ...state,
        getInvoiceDetailPending: false,
        invoiceDetail: action.data
      }
    }

    case types.GET_USER_INVOICE_ERROR: {
      return {
        ...state,
        getInvoiceDetailPending: false,
        getInvoiceDetailError: error?.response?.data?.message,

      }
    }
    ////-----------------------end invoice-detail----------------


    ////-----------------------start user-invoices----------------
    case types.GET_INVOICELIST_REQUEST: {
      return {
        ...state,
        getUserInvoicesPending: true,
        getUserInvoicesError: '',
        activePackageSuccess: false,
        userInvoices: null

      }
    }

    case types.GET_USER_INVOICES_SUCCESS: {

      return {
        ...state,
        getUserInvoicesPending: false,

        userInvoices: action.data
      }
    }

    case types.GET_USER_INVOICES_ERROR: {
      return {
        ...state,
        getUserInvoicesPending: false,
        getUserInvoicesError: error?.response?.data?.message,

      }
    }
    ////-----------------------end user-invoices----------------



    ////-----------------------start getting package by package id----------------
    case types.GET_PACKAGE_BY_ID_REQUEST: {
      return {
        ...state,
        getPackageByPackageIDPending: true,
        getPackageByPackageIDError: '',
        getPackageByPackageIDSuccess: false,
        getPackageByPackageIdResult: null

      }
    }

    case types.GET_PACKAGE_BY_ID_SUCCESS: {
      return {
        ...state,
        getPackageByPackageIDPending: false,
        getPackageByPackageIDSuccess: false,
        getPackageByPackageIdResult: action.data
      }
    }

    case types.GET_PACKAGE_BY_ID_ERROR: {
      return {
        ...state,
        getPackageByPackageIDPending: false,
        getPackageByPackageIDError: error?.response?.data?.message,

      }
    }
    ////-----------------------end getting package by package id----------------

    case types.GET_UPGRADABLE_PACKAGES_REQUEST: {
      return {
        ...state,
        getUpgradablePackagesPending: true,
        getUpgradablePackagesError: '',
        getUpgradablePackagesResult: {}

      }
    }

    case types.GET_UPGRADABLE_PACKAGES_SUCCESS: {

      return {
        ...state,
        getUpgradablePackagesPending: false,
        getUpgradablePackagesResult: action.data
      }
    }

    case types.GET_UPGRADABLE_PACKAGES_ERROR: {
      return {
        ...state,
        getUpgradablePackagesPending: false,
        getUpgradablePackagesError: error

      }
    }

    case types.GET_PACKAGE_SERVICE_ID_REQUEST: {
      return {
        ...state,
        getPackageServiceIDPending: true,
        getPackageServiceIDError: '',
        getPackageServiceIDResult: null

      }
    }

    case types.GET_PACKAGE_SERVICE_ID_SUCCESS: {

      return {
        ...state,
        getPackageServiceIDPending: false,
        getPackageServiceIDResult: action.data
      }
    }

    case types.GET_PACKAGE_SERVICE_ID_ERROR: {
      return {
        ...state,
        getPackageServiceIDPending: false,
        getPackageServiceIDError: error

      }
    }

    case types.GET_CLIENT_PRODUCT_REQUEST: {
      return {
        ...state,
        getClientProductPending: true,
        getClientProductError: '',
        getClientProductSuccess: null

      }
    }

    case types.GET_CLIENT_PRODUCT_SUCCESS: {

      return {
        ...state,
        getClientProductPending: false,
        getClientProductSuccess: true
      }
    }

    case types.GET_CLIENT_PRODUCT_ERROR: {
      return {
        ...state,
        getClientProductPending: false,
        getClientProductError: error

      }
    }



    case types.GET_UPGRADE_PACKAGE_REQUEST: {
      return {
        ...state,
        upgradePackagePending: true,
        upgradePackageError: '',
        upgradePackageResult: null

      }
    }

    case types.GET_UPGRADE_PACKAGE_SUCCESS: {

      return {
        ...state,
        upgradePackagePending: false,
        upgradePackageResult: JSON.parse(action.data)
      }
    }

    case types.GET_UPGRADE_PACKAGE_ERROR: {
      return {
        ...state,
        upgradePackagePending: false,
        upgradePackageError: error

      }
    }


    case types.SET_ACTIVE_PACKAGE: {
      return {
        ...state,
        packageState: {
          hasPackage: action.hasPackage,
          package: action.package
        }


      }
    }


    case types.RESET_USER_PACKAGE
      : {

        return {
          ...state,
          listData: {}
        }
      }


    case types.PACKAGE_RESET_PROPS: {

      return {
        ...state,
        activePackagePending: false,
        activePackageSuccess: false,
        activePackageError: false,
        getAvailablePackagesPending: false,
        getAvailablePackagesError: null,
        getPackageByPackageIDPending: true,
        getPackageByPackageIDError: '',
        getPackageByPackageIDSuccess: false,
        getClientProductPending: false,
        getClientProductError: '',
        getClientProductResult: null,
        upgradePackagePending: false,
        upgradePackageError: '',
        upgradePackageResult: null
      }
    }


    default:
      return state
  }
}

export default packageReducer;